import React, { useEffect, useState } from "react";
import {
  Col,
  Input,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";
import RestroOrderService from "../../../../../services/RestroOrder/RestroOrderService";

const NoteModal = ({
  isOpen,
  toggle,
  selectedNote,
  onSubmit,
  productExtrasMap,
}) => {
  const [extraData, setExtraData] = useState([]);
  const [note, setNote] = useState("");
  const [selectedExtras, setSelectedExtras] = useState({});

  // Load previous note + extras for this product
  useEffect(() => {
    if (!selectedNote?.productId) return;

    const prevData = productExtrasMap?.[selectedNote?.productId];

    setNote(prevData?.note || "");

    setSelectedExtras(
      prevData?.extras?.reduce((acc, item) => {
        acc[item.ExtraItemID] = item;
        return acc;
      }, {}) || {}
    );

    // Fetch extras for this product
    const fetchAll = async () => {
      try {
        const data = await RestroOrderService.extraListItem();
        const filtered = data.filter(
          (item) => item?.ItemID === selectedNote?.productId
        );
        setExtraData(filtered);
      } catch (error) {
        console.error("Error fetching extras:", error);
      }
    };

    fetchAll();
  }, [selectedNote?.productId, productExtrasMap]);

  // Handle checkbox
  const handleCheck = (item) => {
    setSelectedExtras((prev) => {
      if (prev[item.ExtraItemID]) {
        const updated = { ...prev };
        delete updated[item.ExtraItemID];
        return updated;
      }

      return {
        ...prev,
        [item.ExtraItemID]: { ...item, qty: 1 },
      };
    });
  };

  // Handle quantity
  const handleQtyChange = (item, qty) => {
    setSelectedExtras((prev) => ({
      ...prev,
      [item.ExtraItemID]: {
        ...prev[item.ExtraItemID],
        qty: Number(qty),
      },
    }));
  };

  // Submit
  const handleSubmit = () => {
    const extras = Object.values(selectedExtras).map((item) => ({
      ExtraItemID: item.ExtraItemID,
      ExtraItem: item.ExtraItem,
      ExtraPrice: item.ExtraPrice,
      qty: item.qty,
    }));

    const payload = {
      productId: selectedNote.productId,
      note,
      extras,
    };

    if (onSubmit) onSubmit(payload);

    toggle();
  };

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="bottom"
      scrollable={false} // we’ll handle scroll manually
      className="d-block d-lg-none bg-light"
      style={{
        height: "90vh",
        maxHeight: "100vh",
        transition: "transform 0.3s ease",
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        zIndex: 1050,
      }}
    >
      <OffcanvasHeader className="border-bottom">
        <h5 className="mb-0">Add Note & Extras</h5>
      </OffcanvasHeader>

      <OffcanvasBody
        className=""
        style={{
          overflowY: "auto", // make content scrollable
          maxHeight: "calc(90vh - 70px)", // subtract header/footer height as needed
        }}
      >
        {/* Note Section */}
        <div className="mb-4">
          <Label for="note" className="fw-semibold">
            Note:
          </Label>
          <Input
            id="note"
            type="textarea"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Enter your note here..."
          />
        </div>

        {/* Extras Section */}
        <h5 className="mb-3">Extra Items</h5>

        {extraData.map((item) => {
          const isSelected = !!selectedExtras[item.ExtraItemID];
          const qty = selectedExtras[item.ExtraItemID]?.qty || 1;

          return (
            <div
              key={item.ExtraItemID}
              className="d-flex align-items-center justify-content-between my-2 p-2 border rounded"
            >
              <div className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCheck(item)}
                />
                <div>
                  <h6 className="mb-1">{item.ExtraItem}</h6>
                  <small className="text-muted">Rs. {item.ExtraPrice}</small>
                </div>
              </div>

              <Input
                type="number"
                min={1}
                value={qty}
                disabled={!isSelected}
                onChange={(e) => handleQtyChange(item, e.target.value)}
                style={{ width: "70px" }}
              />
            </div>
          );
        })}

        <Row className="sticky-bottom bottom-0 ">
          <Col xs={6}>
            <button className="btn btn-success w-100" onClick={handleSubmit}>
              Submit
            </button>
          </Col>
          <Col xs={6}>
            <button className="btn btn-danger w-100" onClick={toggle}>
              Cancel
            </button>
          </Col>
        </Row>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default NoteModal;
